import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  LAYOUT_DECLARATIONS,
  LAYOUT_ENTRY_COMPONENTS,
  LAYOUT_IMPORTS,
} from './layout/layout.imports';
import {
  UI_DECLARATIONS,
  UI_ENTRY_COMPONENTS,
  UI_IMPORTS,
  UI_PROVIDERS,
} from './ui/ui.imports';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  OwlDateTimeModule,
  OwlMomentDateTimeModule,
  OwlNativeDateTimeModule,
} from '@busacca/ng-pick-datetime';

@NgModule({
  declarations: [
    ...LAYOUT_DECLARATIONS,
    ...UI_DECLARATIONS,
    FooterComponent,
    HeaderComponent,
  ],
  imports: [
    FontAwesomeModule,
    ...LAYOUT_IMPORTS,
    ...UI_IMPORTS,
    NgxSpinnerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule,
  ],
  providers: [...UI_PROVIDERS],
  exports: [
    ...LAYOUT_DECLARATIONS,
    ...UI_DECLARATIONS,
    // ...LAYOUT_IMPORTS,
    ...UI_IMPORTS,
    ...LAYOUT_ENTRY_COMPONENTS,
    ...UI_ENTRY_COMPONENTS,
    FooterComponent,
    HeaderComponent,
    NgxSpinnerModule,
  ],
})
export class SharedModule {}
